<template>
    <div>
        <p class="mb-4"><strong>I'm interested in...</strong></p>
        <!-- Category Tags-->
        <div class="flex flex-wrap mb-24">
            <a
                v-for="tag in categoryTags"
                :key="tag.slug"
                @click="toggleTag(tag)"
                :class="{active: tag.active}"
                class="tag tag-toggle uppercase"
            >
                {{ tag.name }}
            </a>
        </div>
        <p class="mb-4"><strong>across...</strong></p>
        <!-- Channel Tags-->
        <div class="flex flex-wrap mb-24">
            <a
                v-for="tag in channelTags"
                :key="tag.slug"
                @click="toggleTag(tag)"
                :class="{active: tag.active}"
                class="tag tag-toggle uppercase"
                :data-name="tag.name"
            >
                {{ tag.name }}
            </a>
        </div>
        <p class="mb-4"><strong>but only...</strong></p>
        <!--Fixed Filters-->
        <div class="flex flex-wrap mb-24">
            <a @click="toggleFavourites" :class="{active: filterFavourites}" class="tag tag-toggle">My Favourites</a>
            <a @click="toggleNewInsights" :class="{active: filterNewInsights}" class="tag tag-toggle">New Comments</a>
            <a @click="toggleNewActions" :class="{active: filterNewActions}" class="tag tag-toggle">Outstanding Actions</a>
        </div>
    </div>
</template>

<script>
    import { call, get, sync } from 'vuex-pathify';

    export default {
        name: 'chart-filtering',

        data() {
            return {
                filterFavourites: false,
                filterNewActions: false,
                filterNewInsights: false,
            }
        },

        computed: {
            chartFilters: sync('charts/filters'),
            currentClient: get('auth/client'),
            tags: get('tags/tags'),

            categoryTags() {
                return this.tags.filter(tag => tag.type === 'category')
            },

            channelTags() {
                return this.tags.filter(tag => tag.type === 'channel')
            },

            isLoggedIn() {
                return this.currentClient && this.currentClient.id ? true : false
            },
        },

        watch: {
            currentClient(newValue, oldValue) {
                if (this.isLoggedIn) {
                    this.loadTags()
                }
            }
        },

        async mounted() {
            if (this.isLoggedIn) {
                await this.loadTags()
                await this.setFilters()
            }
        },

        methods: {
            loadCharts: call('charts/loadCharts'),
            loadTags: call('tags/loadTags'),

            addTagFilter(tag) {
                let tags = []

                if (this.chartFilters.tags) {
                    tags = this.chartFilters.tags
                }

                this.$set(tag, 'active', true)

                tags.push(tag)

                this.$set(this.chartFilters, 'tags', tags)
            },

            removeTagFilter(tag) {
                if (!this.chartFilters.tags) {
                    return
                }

                this.chartFilters.tags = this.chartFilters.tags.map(t => {
                    if (t.slug === tag.slug) {
                        this.$set(tag, 'active', false)
                    } else {
                        return t
                    }
                }).filter(Boolean)
            },

            async setFilters() {
                const urlParams = new URLSearchParams(window.location.search);
                let filters = urlParams.get('filters');

                if (! filters) {
                    return
                }

                filters = filters.split(',')

                if (filters.find(item => item === 'new_actions')) {
                    this.chartFilters.new_actions = true
                    this.filterNewActions = true
                }

                if (filters.find(item => item === 'new_insights')) {
                    this.chartFilters.new_insights = true
                    this.filterNewInsights = true
                }

                await this.loadCharts()
            },

            async toggleFavourites() {
                if (this.filterFavourites) {
                    delete this.chartFilters.favourites
                } else {
                    this.chartFilters.favourites = true
                }

                this.filterFavourites = !this.filterFavourites

                await this.loadCharts()
            },

            async toggleNewActions() {
                if (this.filterNewActions) {
                    delete this.chartFilters.new_actions
                } else {
                    this.chartFilters.new_actions = true
                }

                this.filterNewActions = !this.filterNewActions

                await this.loadCharts()
            },

            async toggleNewInsights() {
                if (this.filterNewInsights) {
                    delete this.chartFilters.new_insights
                } else {
                    this.chartFilters.new_insights = true
                }

                this.filterNewInsights = !this.filterNewInsights

                await this.loadCharts()
            },

            async toggleTag(tag) {
                if (tag.active) {
                    this.removeTagFilter(tag)
                } else {
                    this.addTagFilter(tag)
                }

                await this.loadCharts()
            },
        },
    }
</script>
